var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._g({staticClass:"base-icon",class:_vm.icon,style:({ ..._vm.cssProps, ..._vm.styleIcon, ..._vm.styleRotation }),attrs:{"width":_vm.width,"height":_vm.height}},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }